import type { StaticDataRouteOption } from "@tanstack/react-router"

import { AppNavigation } from "../NavigationView/AppNavigation"
import { FormsViewTopBar } from "./TopBar"

export const formsViewLayoutHandle: StaticDataRouteOption = {
	leftSlideOut: AppNavigation,
	topBar: FormsViewTopBar,
}
